export { LobTabs, default } from './lobTabs'
export type { LobTabItem, LobTabsProps } from './lobTabs'
